import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { addAdsBanners } from "../../Redux/Actions/banner_adsActions";
import { useDispatch, useSelector } from "react-redux";
import AddImage from "../../Global Functions/addImage";
import { viewCountryListPagination } from "../../Redux/Actions/settingsActions";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";
import "./addAdsBanner.css";

const AddAdsBanners = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dropdownType = ["ad", "banner", "event"];

  useEffect(() => {
    dispatch(viewCountryListPagination());
  }, [dispatch]);

  const { countryList } = useSelector((state) => state.country);

  const [adsData, setAdsData] = useState({
    title: "",
    type: "",
    start_date: "",
    end_date: "",
    country_id: "",
    is_global: true,
    cover_photo: "",
    file_type: "",
    description: "",
    external_link: "",
  });

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    setAdsData((prev) => {
      let updatedState = { ...prev, [name]: value };
      if (name === "start_date" && new Date(updatedState.end_date) < new Date(value)) {
        updatedState.end_date = value;
      }
      return updatedState;
    });
  };

  const validateForm = () => {
    if (!adsData.title?.trim()) { toast.error("Title is required"); return false; }
    if (!adsData.type?.trim()) { toast.error("Type is required"); return false; }
    if (!adsData.start_date?.trim()) { toast.error("Start Date is required"); return false; }
    if (!adsData.end_date?.trim()) { toast.error("End Date is required"); return false; }
    if (adsData.start_date && adsData.end_date && new Date(adsData.end_date) < new Date(adsData.start_date)) {
      toast.error("End Date cannot be before Start Date"); return false;
    }
    if (!adsData.country_id?.trim()) { toast.error("Country selection is required"); return false; }
    if (!adsData.cover_photo?.trim()) { toast.error("Please upload a banner image or video"); return false; }
    if (!adsData.description?.trim()) { toast.error("Description is required"); return false; }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    const fileType = adsData.cover_photo.split(".").pop()?.toLowerCase();
    let fileTypeValue = "";

    if (["jpeg", "jpg", "png", "webp"].includes(fileType)) {
      fileTypeValue = "image";
    } else if (["mp4", "avi"].includes(fileType)) {
      fileTypeValue = "video";
    }

    if (!fileTypeValue) { toast.error("Please upload a valid file!"); return; }

    const payload = { ...adsData, file_type: fileTypeValue };

    try {
      const response = await dispatch(addAdsBanners(payload));
      if (response.statusCode === 200) {
        setAdsData({
          title: "", type: "", start_date: "", end_date: "", country_id: "",
          is_global: true, cover_photo: "", file_type: "", description: "", external_link: "",
        });
        navigate("/dealsAndOffers");
      } else {
        toast.error(response?.message || "Submission failed");
      }
    } catch (error) {
      toast.error(error?.message || "An error occurred");
    }
  };

  return (
    <MainLayout>
      <div className="aab-wrapper">

        {/* ── Header ── */}
        <div className="aab-header">
          <div className="aab-header-left">
            <div className="aab-header-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="2" y="3" width="20" height="14" rx="2"/>
                <path d="M8 21h8M12 17v4"/>
              </svg>
            </div>
            <div>
              <h1 className="aab-title">Add Ads & Banners</h1>
              <p className="aab-subtitle">Create a new advertisement or banner</p>
            </div>
          </div>
          <button className="aab-view-btn" type="button" onClick={() => navigate("/dealsAndOffers")}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"/>
            </svg>
            View List
          </button>
        </div>

        {/* ── Form ── */}
        <div className="aab-form">

          {/* ── Card 1: Basic Info ── */}
          <div className="aab-card">
            <div className="aab-card-header">
              <span className="aab-card-badge">01</span>
              <h2 className="aab-card-title">Basic Information</h2>
            </div>
            <div className="aab-grid aab-grid-2">
              <div className="aab-field">
                <label className="aab-label">Title <span className="aab-req">*</span></label>
                <input
                  className="aab-input"
                  type="text"
                  name="title"
                  value={adsData.title}
                  onChange={handleAddChange}
                  placeholder="Enter title"
                />
              </div>

              <div className="aab-field">
                <label className="aab-label">Type <span className="aab-req">*</span></label>
                <select className="aab-select" name="type" value={adsData.type} onChange={handleAddChange}>
                  <option value="">Select an Option</option>
                  {dropdownType.map((item) => (
                    <option key={item} value={item}>
                      {item.charAt(0).toUpperCase() + item.slice(1)}
                    </option>
                  ))}
                </select>
              </div>

              <div className="aab-field">
                <label className="aab-label">Country <span className="aab-req">*</span></label>
                <select className="aab-select" name="country_id" value={adsData.country_id} onChange={handleAddChange}>
                  <option value="">Select an Option</option>
                  {Array.isArray(countryList?.data)
                    ? countryList.data.map((country) => (
                        <option key={country._id} value={country._id}>{country.country_name}</option>
                      ))
                    : null}
                </select>
              </div>

              <div className="aab-field aab-field--full">
                <label className="aab-label">Description <span className="aab-req">*</span></label>
                <textarea
                  className="aab-textarea"
                  name="description"
                  value={adsData.description}
                  onChange={handleAddChange}
                  rows={3}
                  placeholder="Enter a description for this ad or banner…"
                />
              </div>

              <div className="aab-field">
                <label className="aab-label">External Link</label>
                <input
                  className="aab-input"
                  type="text"
                  name="external_link"
                  value={adsData.external_link}
                  onChange={handleAddChange}
                  placeholder="https://example.com"
                />
              </div>
            </div>
          </div>

          {/* ── Card 2: Validity ── */}
          <div className="aab-card">
            <div className="aab-card-header">
              <span className="aab-card-badge">02</span>
              <h2 className="aab-card-title">Validity Period</h2>
            </div>
            <div className="aab-grid aab-grid-2">
              <div className="aab-field">
                <label className="aab-label">Start Date <span className="aab-req">*</span></label>
                <input
                  className="aab-input"
                  type="date"
                  name="start_date"
                  value={adsData.start_date}
                  onChange={handleAddChange}
                  min={new Date().toISOString().split("T")[0]}
                  max={adsData.end_date || undefined}
                />
              </div>
              <div className="aab-field">
                <label className="aab-label">End Date <span className="aab-req">*</span></label>
                <input
                  className="aab-input"
                  type="date"
                  name="end_date"
                  value={adsData.end_date}
                  onChange={handleAddChange}
                  min={adsData.start_date || new Date().toISOString().split("T")[0]}
                />
              </div>
            </div>
          </div>

          {/* ── Card 3: Media Upload ── */}
          <div className="aab-card">
            <div className="aab-card-header">
              <span className="aab-card-badge">03</span>
              <h2 className="aab-card-title">Banner / Media</h2>
            </div>

            <input
              accept=".jpg,.jpeg,.png,.webp,.mp4,.avi"
              onChange={async (event) => {
                const uploadedFile = event.target.files[0];
                if (uploadedFile) {
                  const allowedTypes = [
                    "image/jpeg", "image/jpg", "image/png", "image/webp",
                    "video/mp4", "video/x-msvideo",
                  ];
                  if (!allowedTypes.includes(uploadedFile.type)) {
                    toast.error("Only JPG, JPEG, PNG, WebP, MP4, and AVI files are allowed!");
                    event.target.value = "";
                    return;
                  }
                  const responseUrl = await AddImage(uploadedFile);
                  if (responseUrl) {
                    setAdsData((prevData) => ({ ...prevData, cover_photo: responseUrl }));
                  }
                }
                event.target.value = "";
              }}
              id="aab-media-upload"
              hidden
              type="file"
            />

            <label className="aab-upload-zone" htmlFor="aab-media-upload">
              {adsData.cover_photo ? (
                <span className="aab-upload-success">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  File uploaded successfully
                </span>
              ) : (
                <>
                  <div className="aab-upload-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                      <polyline points="17 8 12 3 7 8"/>
                      <line x1="12" y1="3" x2="12" y2="15"/>
                    </svg>
                  </div>
                  <span className="aab-upload-text">Click to upload image or video</span>
                  <span className="aab-upload-hint">JPG, PNG, WebP, MP4, AVI</span>
                </>
              )}
            </label>

            <ImageShowerModalGlobal
              keyField="cover_photo"
              setState={setAdsData}
              state={adsData}
              file={adsData.cover_photo}
            />
          </div>

          {/* ── Footer ── */}
          <div className="aab-footer">
            <button type="button" className="aab-btn aab-btn--cancel" onClick={() => navigate("/dealsAndOffers")}>
              Cancel
            </button>
            <button type="button" className="aab-btn aab-btn--submit" onClick={handleSubmit}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              Submit
            </button>
          </div>

        </div>
      </div>
    </MainLayout>
  );
};

export default AddAdsBanners;